// extracted by mini-css-extract-plugin
export default {"urlEmbedInputBox":"styles_urlEmbedInputBox__Ju4r9","urlInput":"styles_urlInput__+eTDv"};